import React from 'react';
import './Footer.css';
import siteContent from '../../data/siteContent';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">© 2026 KINI Consulting Group. All rights reserved.</div>

        <div className="footer__links">
          {siteContent.footerLinks.map((link) => (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;